import { ElementRef, forwardRef } from 'react';
import {
  Portal,
  Content,
  DropdownMenuContentProps as BaseProps,
} from '@radix-ui/react-dropdown-menu';

import { cn } from 'styles';

export type DropdownMenuContentProps = Pick<
  BaseProps,
  'sideOffset' | 'align' | 'side' | 'alignOffset' | 'className'
>;

export const DropdownMenuContent = forwardRef<ElementRef<typeof Content>, BaseProps>(
  ({ className, sideOffset = 4, ...props }, ref) => (
    <Portal>
      <Content
        ref={ref}
        sideOffset={sideOffset}
        // Do not refocus trigger on close. Add prop to control this later
        onCloseAutoFocus={(e) => e.preventDefault()}
        className={cn(
          'z-50 min-w-[8rem] overflow-hidden rounded-md border bg-popover p-1 text-popover-foreground shadow-md data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2',
          className,
        )}
        {...props}
      />
    </Portal>
  ),
);

DropdownMenuContent.displayName = Content.displayName;
